export default "__VITE_ASSET__CUP9MtDq__"